import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IState } from '../../../reducers';

import {SearchBox} from './searchBox';

const mapStateToProps = (state: IState, ownProps: any) => ({
});

export const SearchBoxContainer = connect(
    mapStateToProps
)(withRouter(SearchBox));


// WEBPACK FOOTER //
// ./src/common/components/searchBox/searchBoxContainer.tsx